<template>
    <v-container grid-list-xl>
        <v-layout mt-6>
            <v-btn @click="$router.go(-1)" class="my-6" xs1>
                <v-icon>navigate_before</v-icon>
                {{ $t('back') }}
            </v-btn>

            <div v-if="!!getTest" class="display-2 font-weight-thin ml-6 my-auto">
                {{ getTest.title }}
            </div>

            <v-btn v-if="!!getTest && getTest.draft" @click="editTitle" class="my-auto" text>
                <v-icon>edit</v-icon>
            </v-btn>

            <v-spacer/>

            <div v-if="!!getTest && getTest.done" class="display-1 font-weight-light deep-orange--text my-auto mr-8">
                {{ $i18n.t('done') }}
            </div>

            <div v-else-if="!!getTest && getTest.final" class="display-1 font-weight-light blue-grey--text my-auto mr-8">
                {{ $i18n.t('final') }}
            </div>

            <div v-else-if="!!getTest && getTest.draft" class="display-1 font-weight-light brown--text my-auto mr-8">
                {{ $i18n.t('draft')}}
            </div>
        
            <v-btn  v-if="!!getTest && getTest.draft" class="my-auto mr-4" @click="removing = !removing">
                {{ $t('discard') }}
                <v-icon right>clear</v-icon>
            </v-btn>

            <v-btn v-if="!!getTest && getTest.draft" class="my-auto mr-4" color="teal" @click="makingFinal = !makingFinal">
                {{ $t('makeFinal') }}
                <v-icon right>done</v-icon>
            </v-btn>

            <v-btn v-if="!!getTest && getTest.final" @click="insertIndexes" class="my-auto mr-8" color="teal">
                {{ $t('insertIndexes') }}
                <v-icon right>post_add</v-icon>
            </v-btn>
        </v-layout>

        <v-layout mt-4 mb-2>
            <v-spacer/>

            <div class="headline font-weight-light">
                {{ $t('models') }}
            </div>

            <template class="my-auto">
            <v-text-field readonly dense outlined style="width: 150px" class="shrink ml-3 mr-12"
                v-model="tests"
                prepend-icon="remove"
                @click:prepend="tests = down(tests, 1, 1)"
                append-outer-icon="add"
                @click:append-outer="tests = up(tests, 10, 1)"/>
            </template>

            <v-speed-dial v-model="speedDial" direction="bottom" style="z-index: 1" class="mr-4">
                <template v-slot:activator>
                    <v-btn v-if="!!getTest && getTest.draft" color="teal">
                        {{ tests == 1 ? $t('viewDraft') : $t('viewDrafts') }}
                        <v-icon right>picture_as_pdf</v-icon>
                    </v-btn>
                    <v-btn v-else color="teal">
                        {{ tests == 1 ? $t('viewTest') : $t('viewTests') }}
                        <v-icon right>picture_as_pdf</v-icon>
                    </v-btn>
                </template>

                <v-btn @click="generatePDF(false)" class="mt-n8">
                    {{ $t('withoutSolutions') }}
                    <v-icon right>library_books</v-icon>
                </v-btn>

                <v-btn @click="generatePDF(true)">
                    {{ $t('withSolutions') }}
                    <v-icon right>library_add_check</v-icon>
                </v-btn>
            </v-speed-dial>
        </v-layout>

        <v-expand-transition>
            <v-card v-show="makingFinal" height="57" class="mx-auto mb-4 mt-n4">
                <v-alert v-show="makingFinal" outlined type="warning">
                    <v-layout row>
                        <div  class="my-auto ml-4">
                            {{ $i18n.t('confirmMakeFinal') }}
                        </div>
                        <v-spacer/>
                        <v-btn @click="makeTestFinal" color="orange" class="mr-4">
                            {{ $t('accept') }}
                            <v-icon right>done</v-icon>
                        </v-btn>
                        <v-btn @click="makingFinal = false" class="mr-4">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-layout>
                </v-alert>
            </v-card>
        </v-expand-transition>

        <v-expand-transition>
            <v-card v-show="removing" height="57" class="mx-auto mb-4 mt-n4">
                <v-alert v-show="removing" outlined type="error">
                    <v-layout row>
                        <div  class="my-auto ml-4">
                            {{ $i18n.t('confirmDiscardTest') }}
                        </div>
                        <v-spacer/>
                        <v-btn @click="discard" color="red darken-1" class="mr-4">
                            {{ $t('discard') }}
                            <v-icon right>delete</v-icon>
                        </v-btn>
                        <v-btn @click="removing = false" class="mr-4">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-layout>
                </v-alert>
            </v-card>
        </v-expand-transition>

        <v-card>
            <v-card-text>
                <v-container grid-list-xl>
                    <v-layout row>
                        <v-spacer/>
                            <v-btn v-if="!!getTest && getTest.draft && getQuestions.length > 1" @click="$store.dispatch('randomizeTest')" class="my-2 mx-4" color="teal">
                            {{ $t('randomize') }}
                            <v-icon right>shuffle</v-icon>
                        </v-btn>
                        <v-btn v-if="!!getTest && getTest.draft" @click="$router.push('/tests/' + $route.params.id + '/addQuestions')" class="my-2 mx-4" color="teal">
                            {{ $t('addQuestions') }}
                            <v-icon right>add</v-icon>
                        </v-btn>
                    </v-layout>

                    <v-data-table
                        :headers="questionHeaders"
                        :items="getFormulationsByTest"
                        :items-per-page="-1"
                        :loading="isLoading"
                        :loading-text="$i18n.t('loading')"
                        :no-results-text="$t('noResults')"
                        :no-data-text="$t('noData')"
                        ref="datatable">

						<template v-slot:header.discrimination="{ header }">
						    <v-tooltip bottom>
							    <template v-slot:activator="{ on }">
							        <span v-on="on">{{ $t('discrimination') }}</span>
								</template>
								<span>{{ $t('discriminationTooltip') }}</span>
							</v-tooltip>
						</template>

						<template v-slot:header.difficulty="{ header }">
						    <v-tooltip bottom>
							    <template v-slot:activator="{ on }">
							        <span v-on="on">{{ $t('difficulty') }}</span>
								</template>
								<span>{{ $t('difficultyTooltip') }}</span>
							</v-tooltip>
						</template>

                        <template v-slot:item.id="{ item }">
                            {{ item.question.id }}
                        </template>

                        <template v-slot:item.difficulty="{ item }">
                            <div v-if="!!getTest && getTest.done">
                                {{ item.difficulty }}
                            </div>
                            <div v-else-if="!!item.question.difficulty">
                                {{ (item.question.difficulty).toFixed(2) }}
                            </div>
                            <div v-else>-</div>
                        </template>

                        <template v-slot:item.discrimination="{ item }">
                            <div v-if="!!getTest && getTest.done">
                                {{ item.discrimination }}
                            </div>
                            <div v-else-if="!!item.question.discrimination">
                                {{ (item.question.discrimination).toFixed(2) }}
                            </div>
                            <div v-else>-</div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-tooltip open-on-hover open-delay=200 max-width=220 bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="!!getTest ? on : ''" v-if="!!getTest && getTest.draft" @click="removeQuestion(item.question)" color="gray" class="mr-2">clear</v-icon>
                                </template>
                                <span>{{ $i18n.t('deleteQuestionTooltip') }}</span>
                            </v-tooltip>

                            <v-tooltip open-on-hover open-delay=200 max-width=220 bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" @click="viewQuestion(item.question)" color="gray">remove_red_eye</v-icon>
                                </template>
                                <span>{{ $i18n.t('viewQuestion') }}</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card v-if="!!getTest && !getTest.draft && !!getTest.notes" class="mt-6">
            <v-card-text>
                <v-container grid-list-xl>
                    <div class="subtitle-1 font-weight-medium black--text mb-4">
                        {{ $i18n.t('testNotes') }}
                    </div>
                    <div>
                        {{ getTest.notes }}
                    </div>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card class="mt-6">
            <v-card-text>
                <v-row dense>
                    <v-col cols=2>
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th class="text-center">
                                            {{ $i18n.t('total') }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>{{ $i18n.t('questions') }}</th>
                                        <th class="text-center">
                                            {{ getFormulationsByTest.length }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>{{ $i18n.t('advancedPlural') }}</th>
                                        <th class="text-center">
                                            {{ getFormulationsByTest.filter(formulation => formulation.question.basic==0).length }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>{{ $i18n.t('withImage') }}</th>
                                        <th class="text-center">
                                            {{ getFormulationsByTest.filter(formulation => formulation.question.image==true).length }}
                                        </th>
                                    </tr>

                                    <tr v-if="!!getTest && getTest.done">
                                        <th>
                                            <v-tooltip open-on-hover bottom>
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        {{ $i18n.t('difficulty') }}
                                                    </div>
                                                </template>
                                                <span>{{ $i18n.t('difficultyTooltip') }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-center">
                                            {{ average(getFormulationsByTest.map(formulation => formulation.difficulty)) }}
                                        </th>
                                    </tr>
                                    <tr v-else>
                                        <th>
                                            <v-tooltip open-on-hover bottom>
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        {{ $i18n.t('historicalDifficulty') }}
                                                    </div>
                                                </template>
                                                <span>{{ $i18n.t('difficultyTooltip') }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-center">
                                            {{ average(getFormulationsByTest.map(formulation => formulation.question.difficulty)) }}
                                        </th>
                                    </tr>

                                    <tr v-if="!!getTest && getTest.done">
                                        <th>
                                            <v-tooltip open-on-hover bottom>
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        {{ $i18n.t('discrimination') }}
                                                    </div>
                                                </template>
                                                <span>{{ $i18n.t('discriminationTooltip') }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-center">
                                            {{ average(getFormulationsByTest.map(formulation => formulation.discrimination)) }}
                                        </th>
                                    </tr>
                                    <tr v-else>
                                        <th>
                                            <v-tooltip open-on-hover bottom>
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        {{ $i18n.t('historicalDiscrimination') }}
                                                    </div>
                                                </template>
                                                <span>{{ $i18n.t('discriminationTooltip') }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-center">
                                            {{ average(getFormulationsByTest.map(formulation => formulation.question.discrimination)) }}
                                        </th>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>

                    <v-col cols=10>
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <th v-for="topic in getTopics" :key="topic.id" class="text-center">
                                            {{ "T" + topic.position }}
                                        </th>
                                    </tr>

                                    <tr>
                                        <td v-for="topic in getTopics" :key="topic.id" align="center">
                                            {{ getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id).length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-for="topic in getTopics" :key="topic.id" align="center">
                                            {{ getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id && formulation.question.basic==0).length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-for="topic in getTopics" :key="topic.id" align="center">
                                            {{ getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id && formulation.question.image).length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-for="topic in getTopics" :key="topic.id" align="center">
                                            <div v-if="!!getTest && getTest.done">
                                                {{ average(getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id).map(formulation => formulation.difficulty)) }}
                                            </div>
                                            <div v-else>
                                                {{ average(getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id).map(formulation => formulation.question.difficulty)) }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-for="topic in getTopics" :key="topic.id" align="center">
                                            <div v-if="!!getTest && getTest.done">
                                                {{ average(getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id).map(formulation => formulation.discrimination)) }}
                                            </div>
                                            <div v-else>
                                                {{ average(getFormulationsByTest.filter(formulation => formulation.question.topicId==topic.id).map(formulation => formulation.question.discrimination)) }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-dialog v-model="viewQuestionDialog" max-width="1300px">
            <EditQuestion v-if="isEditingQuestion"/>
            <QuestionInfo v-else/>
        </v-dialog>

        <v-dialog v-model="insertIndexesDialog" max-width="800px">
            <InsertIndexes/>
        </v-dialog>

        <v-dialog v-model="makeTestFinalDialog" max-width="1300px">
            <MakeTestFinal/>
        </v-dialog>

        <v-dialog v-model="editTestDialog" max-width="1300px">
            <EditTitle/>
        </v-dialog>
</v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import QuestionInfo from '@/components/Question/QuestionInfo'
import EditQuestion from '@/components/Question/EditQuestion'
import InsertIndexes from '@/components/Test/InsertIndexes'
import MakeTestFinal from '@/components/Test/MakeTestFinal'
import EditTitle from '@/components/Test/EditTitle'

import Blob from 'blob';
import FileSaver from 'file-saver';
import Sortable from 'sortablejs';

export default {
    data() {
        return {
            speedDial: false,
            tests: 1,
        }
    },

    methods: {
        viewQuestion(question){
            this.$store.commit('setEditingQuestion', false)
            this.$store.commit('setQuestion', question)
            this.$store.dispatch('getFormulationsByQuestion', question.id)
            if (question.image)
                this.$store.dispatch('getImage', question.id)

            this.$store.commit('setViewQuestionDialog', true)
        },
        removeQuestion(question){
            this.$store.dispatch('deleteFormulation', question.id)
        },
        generatePDF(markedSolutions){
            for (var modelNumber=1; modelNumber<=this.tests; modelNumber++)
                this.$store.dispatch('generatePDF', {markedSolutions, modelNumber})
        },
        discard() {
            this.$store.dispatch('removeTest')
        },
        makeTestFinal(){
            this.$store.commit('resetTestValues')
            this.$store.commit('setMakeTestFinalDialog', true)
            this.$store.commit('setMakingTestFinal', false)
        },
        insertIndexes(){
            this.$store.commit('resetTestValues')
            this.$store.commit('setMakingTestDone', false)
            this.$store.commit('setInsertIndexesDialog', true)
        },
        editTitle(){
            this.$store.commit('resetTestValues')
            this.$store.commit('setEditTestDialog', true)
        },

        average(arr){
            return ((arr.reduce((a,b) => a+b, 0) / arr.filter(a=>!!a).length) || 0).toFixed(2)
        },
        up(value, max, step){
            value = parseFloat(value)
            if (value+step < max)
                return value+step
            else
                return parseFloat(max)
        },
        down(value, min, step){
            value = parseFloat(value)
            if (value-step > min)
                return value-step
            else
                return parseFloat(min)
        }
    },

    created() {
        this.$store.dispatch('getTest', this.$route.params.id)
        .then(() => {
            if (this.getTest.draft){
                let table = this.$refs.datatable.$el.getElementsByTagName('tbody')[0]
                Sortable.create(table, {
                    onEnd: ({ newIndex, oldIndex }) => {
                        this.$store.dispatch('moveFormulation', { oldPosition: oldIndex+1, newPosition: newIndex+1 })
                    }
                })
            }
        })

        this.$store.dispatch('getFormulationsByTest', this.$route.params.id)
        .then((testQuestions) => {
            this.$store.commit('setQuestions', testQuestions.map(formulation => formulation.question))
        })

        this.$store.dispatch('getTopics')
    },

    components: {
        QuestionInfo,
        EditQuestion,
        InsertIndexes,
        MakeTestFinal,
        EditTitle
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTest',
            'getViewQuestionDialog',
            'getInsertIndexesDialog',
            'getMakeTestFinalDialog',
            'isEditingQuestion',
            'isRemovingTest',
            'isMakingTestFinal',
            'getQuestions',
            'getFormulationsByTest',
            'getTopics',
            'getEditTestDialog',
        ]),
        questionHeaders() { 
            return [
                { text: 'ID', value: 'id', align: 'center', sortable: false, width: 30 },
                { text: this.$t('position'), value: 'position', align: 'center', sortable: false, width: 30 },
                { text: this.$t('text'), value: 'question.text', align: 'left', sortable: false },
                { text: this.$t('topic'), value: 'question.topicNumber', align: 'center', sortable: false, width: 90 },
                { text: this.$t('difficulty'), value: 'difficulty', align: 'center', sortable: false, width: 110 },
                { text: this.$t('discrimination'), value: 'discrimination', align: 'center', sortable: false, width: 140 },
                { text: this.$t('actions'), value: 'actions', align: 'center', sortable: false, width: 120 },
            ]
        },
        viewQuestionDialog: {
            get() { return this.getViewQuestionDialog },
            set(value) { this.$store.commit('setViewQuestionDialog', value) },
        },
        insertIndexesDialog: {
            get() { return this.getInsertIndexesDialog },
            set(value) { this.$store.commit('setInsertIndexesDialog', value) },
        },
        removing: {
            get() { return this.isRemovingTest },
            set(value) {
                if (value) this.$store.commit('setMakingTestFinal', false)
                this.$store.commit('setRemovingTest', value)
            }
        },
        makingFinal: {
            get() { return this.isMakingTestFinal },
            set(value) {
                if (value) this.$store.commit('setRemovingTest', false)
                this.$store.commit('setMakingTestFinal', value)
            }
        },
        makeTestFinalDialog: {
            get() { return this.getMakeTestFinalDialog },
            set(value) { this.$store.commit('setMakeTestFinalDialog', value) },
        },
        editTestDialog: {
            get() { return this.getEditTestDialog },
            set(value) { this.$store.commit('setEditTestDialog', value) },
        }
    },
}
</script>

<style scoped>
    .handle {
        cursor: move !important;
        cursor: -webkit-grabbing !important;
    }
</style>
